import { createQueryKeys } from "@lukemorales/query-key-factory"

import axios from "@/api/axios"
import { APIFn } from "@/api/utils"

import {
  Country,
  Currency,
  Curriculum,
  State,
  Subject,
  TeachingLevel,
} from "./types"

export const GlobalQueryKey = createQueryKeys("global", {
  currenciesList: () => ({
    queryKey: ["currency-list"],
  }),
  subjectList: () => ({
    queryKey: ["subject-list"],
  }),
  curriculumList: () => ({
    queryKey: ["curriculum-list"],
  }),
  countryList: () => ({
    queryKey: ["country-list"],
  }),
  stateList: () => ({
    queryKey: ["state-list"],
  }),
  teachingLevelsList: () => ({
    queryKey: ["teaching-levels-list"],
  }),
})

type Resource = {
  currency: { list: APIFn<Currency[]> }
  subjects: { create: APIFn<Subject[]>; list: APIFn<Subject[]> }
  country: { detect: APIFn<Country>; list: APIFn<Country[]> }
  states: { list: APIFn<State[], { countryId: string }> }
  curricula: { create: APIFn<Curriculum[]>; list: APIFn<Curriculum[]> }
  teachingLevels: {
    create: APIFn<TeachingLevel[]>
    list: APIFn<TeachingLevel[]>
  }
}

export const GlobalResource: Resource = {
  currency: {
    list: ({ params }) => axios.get("/gravity/currencies", { params }),
  },
  subjects: {
    create: ({ data }) => axios.post("/gravity/subjects/create/", { ...data }),
    list: ({ params }) =>
      axios.get("/gravity/subjects", {
        params,
      }),
  },
  country: {
    list: ({ params }) =>
      axios.get("/gravity/countries", {
        params,
      }),
    detect: () => axios.get("/global/countries/current"),
  },
  states: {
    list: ({ urlParams, params }) =>
      axios.get(`/gravity/countries/${urlParams.countryId}/states`, {
        params,
      }),
  },
  curricula: {
    create: ({ data }) => axios.post("/gravity/curricula/create/", { ...data }),
    list: ({ params }) =>
      axios.get("/gravity/curricula", {
        params,
      }),
  },
  teachingLevels: {
    create: ({ data }) =>
      axios.post("/gravity/teaching-levels/create/", { ...data }),
    list: ({ params }) =>
      axios.get("/gravity/teaching-levels/", {
        params,
      }),
  },
}
